module.exports = __webpack_public_path__ + "img/Welcome05.536757bf.svg";